/* tslint:disable */
/* eslint-disable */
/**
 * Farseer API
 * Farseer API
 *
 * The version of the OpenAPI document: 3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CustomColumnRepresentationFromJSON, CustomColumnRepresentationToJSON, SheetRowPredicateRepresentationFromJSON, SheetRowPredicateRepresentationToJSON, } from './';
export function SheetRowRepresentationFromJSON(json) {
    return SheetRowRepresentationFromJSONTyped(json, false);
}
export function SheetRowRepresentationFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        id: json['id'],
        parentId: json['parentId'],
        name: json['name'],
        accountTagId: json['accountTagId'],
        dimensionTagIds: json['dimensionTagIds'],
        tableTagId: json['tableTagId'],
        predicate: json['predicate'] === null
            ? null
            : json['predicate'].map(SheetRowPredicateRepresentationFromJSON),
        customColumns: json['customColumns'].map(CustomColumnRepresentationFromJSON),
        readonly: json['readonly'],
        withData: json['withData'],
        hierarchyFlatten: json['hierarchyFlatten'],
        hierarchyMaxDepth: json['hierarchyMaxDepth'],
        order: json['order'],
    };
}
export function SheetRowRepresentationToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        id: value.id,
        parentId: value.parentId,
        name: value.name,
        accountTagId: value.accountTagId,
        dimensionTagIds: value.dimensionTagIds,
        tableTagId: value.tableTagId,
        predicate: value.predicate === null
            ? null
            : value.predicate.map(SheetRowPredicateRepresentationToJSON),
        customColumns: value.customColumns.map(CustomColumnRepresentationToJSON),
        readonly: value.readonly,
        withData: value.withData,
        hierarchyFlatten: value.hierarchyFlatten,
        hierarchyMaxDepth: value.hierarchyMaxDepth,
        order: value.order,
    };
}
